var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._v("View Collection slug: "+_vm._s(_vm.slug))])
}
var staticRenderFns = []

export { render, staticRenderFns }